import { Skeleton } from "@stacklet/ui";

/** Route-level fallback for the Teams integration page: breadcrumb bar and content. */
export function TeamsSkeleton() {
  return (
    <div className="grow">
      <div className="mb-xl mt-xs">
        <Skeleton height={54} variant="rectangular" width="100%" />
      </div>
      <Skeleton height={480} variant="rectangular" width="100%" />
    </div>
  );
}
